import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
    setSnackBar
  } from "../../store/common/commonSlice";

import { 
    setShowPassword,
    login,
    setResetState,
    } from "../../store/auth/authSlice";

const mapStateToProps = (state) => {
    const {
        login_is_loading,
        show_password
    } = state.auth;
    const {
        company_details
    } = state.user;
    return {
        is_loading : login_is_loading,
        show_password : show_password,
        company_details : company_details
    };
};

const mapDispatchToProps = (dispatch) => 
    bindActionCreators(
        {
            setShowPassword,
            login,
            setSnackBar,
            setResetState
        },
        dispatch
    );

const Store = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);

export default Store;